/**
 * Suppresses React 18 deprecation warnings in the browser console.
 * TODO: Remove once EN-82018 is complete and we've migrated to createRoot.
 */
const originalConsoleError = console.error;

const suppressedWarnings = [
  'Warning: ReactDOM.render is no longer supported in React 18',
  'Warning: unmountComponentAtNode is deprecated and will be removed in the next major release',
];

console.error = (...args: any[]) => {
  if (typeof args[0] === 'string' && suppressedWarnings.some((warning) => args[0].includes(warning))) {
    return;
  }
  originalConsoleError.apply(console, args);
};
